export function getFigmaColors(): Record<
  'darkBlue' | 'brightBlue' | 'grey',
  string
> {
  return {
    brightBlue: '#f3f4fb',
    darkBlue: '#1f2a61',
    grey: '#505157',
  }
}
